import { SubmitSingleMemberFirmCreationRequest } from '@bupa-kkv/features/company-creation/types';
import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const submitSelfEmploymentCreations = (
  payload: SubmitSingleMemberFirmCreationRequest
): Promise<void> => {
  return companyCreationAxiosInstance.post(
    'v1/customer/single-member-firm-creations/submit',
    payload
  );
};
